import { registerComponent, scrollLock, triggerEvent } from "helpers";

registerComponent(
  "wyatt-drawer",
  class WyattDrawer extends HTMLElement {
    constructor() {
      super();

      this.openButton = this.querySelector("[data-drawer-open]");
      this.drawer = this.getDrawer();
      this.wrapper = this.drawer.querySelector("[data-drawer-wrapper]");

      this.openButton.addEventListener("click", this.open.bind(this));

      this.handleClickOutside();

      this.drawer.addEventListener("close", this.close.bind(this));
    }

    connectedCallback() {
      document.querySelector("body").append(this.drawer);
    }

    disconnectedCallback() {
      this.drawer.remove();
    }

    open() {
      this.drawer.showModal();
      this.drawer.setAttribute("active", true);
      scrollLock.enable();
      triggerEvent(this.drawer, "drawerOpen");
    }

    close() {
      this.drawer.setAttribute("active", false);
      scrollLock.disable();
      triggerEvent(this.drawer, "drawerClose");
    }

    handleClickOutside() {
      this.drawer.addEventListener("click", () => {
        this.drawer.close();
      });
      this.wrapper.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    }

    getDrawer() {
      return (
        this.querySelector("[data-drawer]") ||
        document.querySelector(this.openButton.dataset.drawerOpen)
      );
    }
  },
);
